import { ACLContext } from './ACL.context';
import { useACL } from './ACL.hook';
import { ACLProviderProps } from './ACL.types';

export default function ACLProvider(props: ACLProviderProps) {
  const { children } = props;
  const acl = useACL();

  return <ACLContext.Provider value={acl}>{children}</ACLContext.Provider>;
}
